/**
 * Extracts the TRPCError code ('NOT_FOUND', 'FORBIDDEN', …) from an unknown
 * error-like value, or '' when there is none. The narrowing is written out
 * rather than cast: the value really is unknown — a tRPC error, a bare `Error`
 * from the refresh wrapper, a network failure — and `as` would only hide which
 * of the three arrived.
 */
export const getErrorCode = (err: unknown): string => {
  if (err === null || typeof err !== 'object' || !('data' in err)) {
    return ''
  }
  const { data } = err
  if (data === null || typeof data !== 'object' || !('code' in data)) {
    return ''
  }
  return typeof data.code === 'string' ? data.code : ''
}
